import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';
import './AboutUs.css';

const AboutUs = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const { language } = useLanguage();
  const t = getTranslation(language);

  return (
    <section className="about-us" ref={ref}>
      <div className="about-us-container">
        <motion.div
          className="about-section"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h1 className="about-title">{t.about.title}</h1>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutUs;
